<div class="container">
    <div class="d-flex justify-content-center align-items-center custom-my-10">
        <h2 class="text-center v4-color-white">{{"There is no data" | translator}}<i  class="pi pi-fw pi-exclamation-triangle font-2rem v4-color-white"></i></h2>
    </div>
</div>
